export default __webpack_public_path__ + "static/media/logo.601448d2.png";